import styled from '@emotion/styled';
import { Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';

const StyledLink = styled('a')`
	color: #ff6d00;

	&:hover,
	&:focus {
		color: inherit; /* Optional: Change hover color */
		text-decoration: none; /* Optional: Change hover text decoration */
	}
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 22px; /* 169.231% */
	letter-spacing: 0.46px;
	cursor: pointer;
`;

function DetailCard({ link }) {
	return (
		<Paper
			sx={{
				width: '350px',
				borderLeft: '5px solid #FF6D00',
				borderRadius: '0px',
				pl: '5px',
			}}
		>
			<Stack>
				<Typography
					sx={{
						color: '#FF6D00',
						fontSize: '14px',
						fontWeight: 600,
						lineHeight: '20px',
						letterSpacing: '0.17px',
						fontFamily: 'Roboto',
					}}
				>
					Cambios detectados en el catálogo
				</Typography>

				<Typography
					sx={{
						color: 'rgba(0, 0, 0, 0.87)',
						fontSize: '14px',
						fontWeight: 400,
						lineHeight: '20px',
						letterSpacing: '0.17px',
						fontFamily: 'Roboto',
					}}
				>
					Otro vendedor se encuentra vinculado al catalogo de tu producto.{' '}
					<span>
						<StyledLink href={link} target="_blank">
							Ir a la publicación
						</StyledLink>
					</span>
				</Typography>
			</Stack>
		</Paper>
	);
}

export default function CatalogFlagCard({ children, link }) {
	return (
		<LightTooltip
			placement="top-start"
			customStyles={{
				maxWidth: '350px',
				padding: '0',
			}}
			title={<DetailCard link={link} />}
		>
			{children}
		</LightTooltip>
	);
}
